import { useState, useEffect, useContext, useRef, useLayoutEffect } from 'react'
import axios from 'axios'
import '../../styles/editenst.scss'
import '../../styles/styles.css'
import { loadingContext, intentsContext, projectContext, urlValue, unfolder,openAlert, useTranslate } from '../../lib'
import SelectContextModal from '../SelectContextModal'
import { useForm } from 'react-hook-form'
import SelectCodeModal from '../SelectCodeModal'
import BoxInfo from '../common/BoxInfo'
import { Tooltip } from 'react-tooltip'
import { Alerts } from '../common/Alerts'
import Button from '../provider/button/button.jsx'
import H2 from '../provider/h2/H2.jsx'
import H3 from '../provider/h3/H3.jsx'

export function EditIntent({ selectedAnswer, setSidePanel, refresh, setRefresh, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [loading, setLoading] = useContext(loadingContext)
  const intentsCtx = useContext(intentsContext);
  const [shownIntent, setShownIntent] = useState('')
  const [answer, setAnswer] = useState()
  const [category, setCategory] = useState(selectedAnswer?.compliance_type)
  const [compliancePhare, setCompliancePhare] = useState(selectedAnswer?.compliance_phare)
  const [multi_phrase, setMulti_phrase] = useState([])
  const [list, setList] = useState([])
  const phraseInput = useRef()
  const nameInput = useRef()
  const dummy = useRef()
  const [inputContext, setInputContext] = useState("")
  const [outputContext, setOutputContext] = useState("")
  const [typeInput, setTypeInput] = useState(false)
  const [errorsIntent, setErrorsIntent] = useState({ name: "" })
  const outputContextStatic = selectedAnswer?.displayName.toLowerCase() + '-followup'
  const [errors, setErrors] = useState({ name: "" })
  const [alert, setAlert] = useState({title: '', visible: false})
  //const outputContextStatic = selectedAnswer.output_context
  let phrase = useRef('')
  let name = useRef('')
  const { t } = useTranslate();

  useEffect(() => {
    setMulti_phrase(selectedAnswer?.multi_phrase || [])
    setCompliancePhare(selectedAnswer?.compliance_phare || "")
    setCategory(selectedAnswer?.compliance_type)
  }, [selectedAnswer])
  const {
    register,
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      technical: ' ',
      type: '1',
    },
  })

  const [isContextModalOpen, setIsContextModalOpen] = useState({ delete: false, code: false })
  const setContextValue = () => {
    console.log('To do')
  }

  const handleCancel = () => {
    setErrors({ ...errors, name: "" })
    setSidePanel('new')
    // update();    
  }

  const openContextModal = (e) => {
    setTypeInput(true)
    setIsContextModalOpen({ delete: false, code: true })
  }

  const openOutputContextModal = () => {
    setTypeInput(false)
    setIsContextModalOpen({ delete: false, code: true })
  }

  function formatContext(fullPath, setContext) {
    try {
      const splitted_in = fullPath.split("/")
      return splitted_in[splitted_in.length - 1]
    }
    catch (e) {
      console.log('It is an error?')
      return null
    }
  }


  String.prototype.rtrim = function () {
    //removes last space from string when invoked
    return this.replace(/((\s*\S+)*)\s*/, '$1')
  }

  const submit = e => {
    e.preventDefault()
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    const input_context = document.querySelector("#input-context").value;
    let user_id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
    const output_context = document.querySelector("#output-context").value;
    const exp = /^[A-Za-zÀ-ÿ0-9-,._-ñ;!@'()-¿?\s]+$/g;
    const exp_spaces = /\s/g;
    if (!exp.test(nameInput.current.value)) {
      ok = false;
      setErrors({ ...errors, name: t('errors.nameInvalid') })
    }

    if (category == null && compliancePhare == "") {
      ok = false
      setErrors({ ...errors, name: t('errors.intentCategoryAndMainSentenceRequired') })
    }

    else if (category == null) {
      ok = false
      setErrors({ ...errors, name: t('errors.intentCategoryRequired') })
    }

    else if (compliancePhare === "") {
      ok = false
      setErrors({ ...errors, name: t('errors.intentMainSentenceRequired') })
    }

    if (ok) {
      setLoading(true)

      axios({
        method: 'put',
        url: `${urlValue}/studio/project/${selectedProject.id}/intent`,
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: JSON.stringify({
          intentName: selectedAnswer.name,
          trainingPhrases: list,
          displayName: nameInput.current.value,
          languageCode: selectedProject?.metadata?.language?.slice(0, 2),
          inputContext: input_context,
          outputContext: output_context,
          multi_phrase,
          compliance_type: category,
          compliance_phare: compliancePhare,
          user_id: user_id.toString(),
          ccms_name: ccms_name.toString(),
        }),
      })
      .then(function (response) {
        setAnswer(response.data)
        setLoading(false)
        update(selectedAnswer.name);
        setErrors({ ...errors, name: "" })

        openAlert('#alert-ac', () => {
          setAlert({title: t('alerts.intentSaved'), visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
   
        // setSidePanel('detail');
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
        openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentNotSaved'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      })
    }
  }

  const handleIntro = e => {
    if (e.key == 'Enter') {
      addPhrase(e)
    }
  }
  const addPhrase = e => {
    e.preventDefault()
    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._'()-¿?\s]+$/g;
    if (!exp.test(phraseInput.current.value)) {
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentPhraseInvalidChars'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (phraseInput.current.value.length > 768) {
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.intentPhraseTooLong'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (ok) {
      setList(prev => [...prev, phrase.current.rtrim()])
      phraseInput.current.value = ''
    }

  }
  const removePhrase = e => {
    e.preventDefault()
    let end = e.target.previousSibling.innerText.length
    let element = e.target.previousSibling.innerText.slice(2, end)
    setList(prev => prev.filter(e => e !== element))
  }

  useEffect(() => {
    if (dummy.current) {
      dummy.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [list])

  useEffect(() => {
    selectContext()
  }, [inputContext, outputContext])

  const selectContext = () => {
    try {
      const full_path_in = selectedAnswer.inputContextNames.toString()
      let inputT = formatContext(full_path_in)
      setInputContext(inputT)
      document.querySelector("#input-context").value = inputT;
      loadChangeCategory()
    }
    catch (e) {
      setInputContext("")
      document.querySelector("#input-context").value = "";
    }
    try {
      const full_path_out = selectedAnswer.outputContexts[0].name.toString()
      let outputT = formatContext(full_path_out)
      setOutputContext(outputT)
      document.querySelector("#output-context").value = outputT;
      setValue('outputContexts', outputT)
    }
    catch (e) {
      setOutputContext("")
      document.querySelector("#output-context").value = "";
    }

    setValue('inputContextNames', inputContext)

    if (inputContext) {
      // setValue('outputContexts', outputContextStatic)      
    }
    setValue('outputContexts', outputContext)
  }

  useEffect(() => {
    name.current = selectedAnswer?.displayName
    // setValue('outputContexts', outputContextStatic)

    nameInput.current.value = name.current
    setShownIntent(selectedAnswer)
    setList(() => selectedAnswer?.trainingPhrases.map(e => e.parts[0].text))
    selectContext()
  }, [selectedAnswer])

  const loadChangeCategory = () => {
    document.querySelector("#compliance").checked = false
    document.querySelector("#resolution").checked = false
    document.querySelector("#conversation").checked = false
    document.querySelector("#disclaimer").checked = false
    switch (selectedAnswer?.compliance_type) {
      case 1:
        document.querySelector("#compliance").checked = true
        break;
      case 2:
        document.querySelector("#resolution").checked = true
        break;
      case 3:
        document.querySelector("#conversation").checked = true
        break;
      case 4:
        document.querySelector("#disclaimer").checked = true
        break;
      default:
        break;
    }
  }
  const loadMultiPhrase = () => {



  }
  useEffect(() => {
    loadChangeCategory();
    loadMultiPhrase();
  }, []);
  const changeCategory = e => {
    document.querySelectorAll(".categories_list .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    switch (e.target.id) {
      case "compliance":
        setCategory(1);
        break;
      case "resolution":
        setCategory(2);
        break;
      case "conversation":
        setCategory(3);
        break;
      case "disclaimer":
        setCategory(4);
        break;
      default:
        break;
    }
  }

  const removePhrase2 = (index, phrase) => {
    setList(prev => prev.filter((e, i) => i !== index));
    setMulti_phrase(prev => prev.filter(x => x !== phrase))
  }


  const changePhrase = (e, phrase) => {

    if (e.target.checked) {
      setMulti_phrase([...multi_phrase, phrase])
    } else {
      setMulti_phrase(prev => prev.filter(x => x !== phrase))
      if (multi_phrase[0] == phrase && multi_phrase.length > 1) {
        phrase = multi_phrase[1]
      }
    }
    if (category === 4) {
      document.querySelectorAll(".newPhrases .checkbox").forEach(element => {
        element.checked = false;
        element.getAttribute("phrase")
      }
      );
      e.target.checked = true;
      setMulti_phrase([phrase])
    }
    setCompliancePhare(phrase);
  }
  const changePhraseName = (e, index) => {
    if (e.target.value) {
      const multiNew = [...multi_phrase]
      const listNew = [...list]
      if (compliancePhare === multiNew[index])
        setCompliancePhare(e.target.value);

      multiNew[index] = e.target.value;
      setMulti_phrase(multiNew)
      listNew[index] = e.target.value;
      setList(listNew)
      
    } 
  }

  useEffect(() => {
    setTimeout(() => {
      document.querySelectorAll(".phrase_selection .phrase-input").forEach(element => {
        const isSeleted = selectedAnswer.multi_phrase?.find(x => x === element.getAttribute("phrase") ? true : false);
        element.checked = isSeleted;
      })
    }, 400)
  }, [selectedAnswer])
  function heigthText(element) {
    element.style.height = "auto";
    element.style.height = (element.scrollHeight) + "px";
}


const ajustarAltura = (index, event) => {
  const textarea = event.target;
  textarea.style.height = 'auto';
  textarea.style.height = `${textarea.scrollHeight}px`;

 
};

const changeName = (e) => {
  if (name.current?.toUpperCase() == 'DEFAULT FALLBACK INTENT') {
    openAlert('#alert-ac', () => {
      setAlert({title: t('alerts.intentDefaultFallbackName'), visible: true})
    }, 4000, ()=>{setAlert({...alert,visible: false})} );
  }
  else {
    name.current = e.target.value.toUpperCase()
  }
  
}

useEffect(() => {
  setTimeout(() => {
  let textareas = document.querySelectorAll(".box-text")
 
    textareas.forEach((element) => {
      element.style.height = `${element.scrollHeight}px`
    
  })    
}, 400)
}, [selectedAnswer])
  return (
    <div className="editIntent" id="intents">
      <div className="Intent ">
        <div className="  scroll-internal-intents ">
          <div className="IntentTitle">
            <H2 text={t('intents.editTitle', { intent: shownIntent?.displayName })} />
          </div>
          <form onKeyPress={handleIntro} onSubmit={submit} className="formInt" style={{margin: '10px 0 0 0'}}>
            <div className='tooltip '>
              <BoxInfo
                id="intent-name"
                titleClass='mr-0-4 f-16  title-intent'
                title={t('common.name') + ':'}
                place="top"
                containerClass='mr-0-5 z-15 '
                render={`<div>
                    ${t('intents.intentNameInfo')}
                  </div>`}
              />
              <input
                id='name-tpin'
                placeholder={t('intents.intentNamePlaceholder')}
                type="text"
                className='input-data'
                onChange={(e) => changeName(e)}
                ref={nameInput}
              />
              <Tooltip anchorSelect="#name-tpin" content={t('alerts.charactersNameTooltip')} place={"top"} />
            </div>

            <div className="con_categories mt-2">
              <BoxInfo
                id="ramvoice-tp"
                titleClass='mr-0-4 f-16 title-intent'
                title={t('intents.category')} style={{fontWeight: 'bold'}}
                place="top"
                containerClass='mr-0-5 z-15 '
                render={`<div>
                          ${t('intents.categoryInfo')}
                        </div>`}
              />
              <div className="categories_list">
                <div className="item">
                  <input id="compliance" type="checkbox" className="checkbox" onChange={changeCategory} />
                  <label htmlFor="compliance " className='sub-title-intent'>{t('reports.compliance')}</label>
                </div>
                <div className="item">
                  <input id="resolution" type="checkbox" className="checkbox" onChange={changeCategory} />
                  <label htmlFor="resolution " className='sub-title-intent'>{t('reports.resolution')}</label>
                </div>
                <div className="item">
                  <input id="conversation" type="checkbox" className="checkbox" onChange={changeCategory} />
                  <label htmlFor="conversation " className='sub-title-intent'>{t('common.conversation')}</label>
                </div>
                <div className="item">
                  <input id="disclaimer" type="checkbox" className="checkbox" onChange={changeCategory} />
                  <label htmlFor="disclaimer " className='sub-title-intent'>{t('reports.disclaimer')}</label>
                </div>
              </div>

            </div>

            {/* // {shownIntent.trainingPhrases && (
            //   <div id="list-phrase" className="newPhrases">
            //     {list.map((element, index) => (
            //       <div className="rendered" key={index}>
            //         <div>{`- ${element}`}</div>
            //         <div className="phrase_selection">
            //           <input type="checkbox" phrase={element} className="checkbox phrase-input" onChange={(e) => changePhrase(e, element)} />
            //           <a className="addsOrSubs" onClick={() => removePhrase2(index, element)}>
            //             -
            //           </a>
            //         </div> */}
            <div className='con_categories' style={{ marginTop: 15 }}>
              <BoxInfo
                  id="intent-context"
                  titleClass='mr-0-4 f-16 title-intent'
                  title={t('intents.context') + ':'}
                  place="top"
                  containerClass='mr-0-5 z-15 '
                  render={`<div>
                      ${t('intents.contextInfo')}
                    </div>`}
              />

              <div className='categories_list'>
                <div className="con_name item" style={{ marginLeft: 0 }}>
                  <BoxInfo
                    id="input-context-info"
                    titleClass='mr-0-4 f-16 title-intent'
                    title={t('intents.inputContext')} titleStyle={{fontWeight: '400'}}
                    place="top"
                    containerClass='mr-0-5 z-15'
                    render={`<div>
                        ${t('intents.inputContextInfo')}
                      </div>`}
                  />
                  <div className="cursor-pointer">
                    <input
                      type="text"
                      id="input-context"
                      {...register('inputContextNames')}
                      onChange={() => { }}
                      className='input-data'
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="con_name item">
                  <BoxInfo
                    id="output-context-info"
                    titleClass='mr-0-4 f-16 title-intent'
                    title={t('intents.outputContext')} titleStyle={{fontWeight: '400'}}
                    place="top"
                    containerClass='mr-0-5 z-15'
                    render={`<div>
                        ${t('intents.outputContextInfo')}
                      </div>`}
                  />
                  <div className="cursor-pointer">
                    <input
                      type="text"
                      id="output-context"
                      className='input-data'
                      onChange={() => { }}
                      {...register('outputContexts')}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="con_training_phrases">
              <BoxInfo
                id="intent-training-phrases"
                titleClass='mr-0-4 f-16 title-intent'
                title={t('intents.trainingPhrases')}
                place="top"
                containerClass='mr-0-5 z-15 '
                render={`<div>
                    ${t('intents.trainingPhrasesInfo')}
                  </div>`}
              />

              <div className="addPhrase  ">
                <input
                  id="train-tp"
                  type="text"
                  placeholder={t('intents.trainingPhrasesPlaceholder')}
                  ref={phraseInput}
                  onChange={e => (phrase.current = e.target.value)}
                  className='input-data'
                />
                <Tooltip anchorSelect="#train-tp" content={t('alerts.charactersNameTooltip')} place={"top"} />
                <button onClick={addPhrase} className="addsOrSubs">
                  <img id='add-tp' onClick={addPhrase} src="/icons/add-icon-nt.png" alt='' style={{ width: 48, height: 25, objectFit: 'contain', cursor: 'pointer' }} />
                </button>
                <Tooltip anchorSelect="#add-tp" content={t('intents.addPhraseTooltip')} place={"top"} />
              </div>

              {shownIntent?.trainingPhrases && (
                <div className="newPhrases input-data" style={{ overflowY: "hidden" }}>
                  <div className="sub-phrase-scroll">
                    {list.map((element, index) => (
                      <div style={{paddingTop:10}} className="rendered flex justify-end" key={element + index}>
                        {/* <div >{`- ${element}`}</div> */}
                        <textarea phrase={element} defaultValue={element} className='edit-input box-text' style={{border:'none', resize: 'none', width: "100%", marginRight: 7, }} onChange={(e) => changePhraseName(e, index)}  ></textarea>
                        <div className="phrase_selection">
                          <input type="checkbox" phrase={element} id='phrase_selection_checkbox' className="checkbox phrase-input" onChange={(e) => changePhrase(e, element)} />
                          <Tooltip anchorSelect="#phrase_selection_checkbox" content={t('intents.selectMainSentenceTooltip')} place={"top"} />
                          <a className="addsOrSubs" id='phrase_selection_delete' onClick={() => removePhrase2(index, element)}>
                            -
                          </a>
                          <Tooltip anchorSelect="#phrase_selection_delete" content={t('common.delete')} place={"top"} />
                        </div>

                      </div>
                    ))}
                    <div ref={dummy}></div>
                  </div>
                </div>
              )}

            </div>

            <div className="buttonsInt">
              {/* <button className="cancel" onClick={handleCancel}>
              Cancel
            </button> */}
              <Button 
                type="button"
                id='cancel-tp'
                label={t('common.cancel')}
                onClick={(handleCancel)}
                className="create btn-bottom btn-bottom-cancel"
                content={t('intents.cancelCreation')}
              />
              {/*
              <button id='cancel-tp' type='button' onClick={() => { update() }} className="create btn-bottom btn-bottom-cancel">Cancel</button>
              <button id='cancel-tp' type='button' onClick={(handleCancel)} className="create btn-bottom btn-bottom-cancel">Cancel</button>
              <Tooltip anchorSelect="#cancel-tp" content={"Cancel creation"} place={"top"} />
              */}

              {/** */}
              <button id='save-tp' className="create btn-bottom btn-bottom-create">{t('common.save')}</button>
              <Tooltip anchorSelect="#save-tp" content={t('intents.saveChangesTooltip')} place={"top"} />
              
            </div>
            <span className='errors-msg'  >{errors.name}</span>
          </form>
        </div>
      </div>
      <SelectContextModal
        isModalOpen={isContextModalOpen} setIsModalOpen={setIsContextModalOpen} setValue={setValue} typeInput={typeInput}
        outputContext={outputContextStatic}
      />
       {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>
  )
}
